import { SpreadsheetDefinition } from '../index';
import { DEFAULT_FIRM_SUMMARY_COLUMNS } from '../valueTypes';

export function normalizeFirmSpreadsheetDefinition(definition?: SpreadsheetDefinition): SpreadsheetDefinition {
  const fallbackColumns = Object.fromEntries(DEFAULT_FIRM_SUMMARY_COLUMNS.map((col, idx) => [idx, col]));
  return {
    columns: definition?.columns ?? fallbackColumns,
    sortKeys: definition?.sortKeys ?? [],
    groupBy: definition?.groupBy ?? 'company',
    filters: definition?.filters ?? [],
    filterExclusions: definition?.filterExclusions ?? [],
    breakevenMultiple: definition?.breakevenMultiple ?? 1,
  };
}
